import Authorize from '@/views/Authorize.vue'
import Home from '@/views/Home.vue'
import MyNotifications from '@/views/MyNotifications.vue'
import MyNotification from '@/views/MyNotification.vue'

import * as Breadcrumbs from '../breadcrumbs/main'

export default [
	{
		path: '/',
		name: 'home',
		component: Home,
		meta: { requiresAuth: true },
	},
	{
		path: '/authorize',
		name: 'authorize',
		component: Authorize,
	},
	{
		path: '/my-notifications',
		name: 'my-notifications',
		component: MyNotifications,
		meta: {
			requiresAuth: true,
			title: 'My Notifications',
			breadcrumb: [
				Breadcrumbs.MyNotifications,
			],
		},
	},
	{
		path: '/my-notifications/:notification',
		name: 'my-notification',
		component: MyNotification,
		meta: {
			requiresAuth: true,
			title: 'My Notifications',
			breadcrumb: [
				Breadcrumbs.MyNotifications,
				Breadcrumbs.MyNotification,
			],
		},
	},
]
